export default class PartEx {
    constructor(parent) {
        this.parent = parent;
        this.myAccount2 = window.HONDA.MyAccount2;
        this.savedValuations = { data: [] };
        this.bind();
    }

    bind() {
        this.myAccount2?.addEventListener('login', () => this.onLogin());
    }

    onLogin() {
        this.savedValuations = { data: [] };
        this.getCarSavedValuations();
    }

    async getCarSavedValuations() {
        this.savedValuationsRequest = this.myAccount2.client.getCarSavedValuations();
        return await this.waitForCarSavedValuations();
    }

    async waitForCarSavedValuations() {
        const results = await this.savedValuationsRequest;
        const data = results?.data;
        this.pushSaved(data);
        return this.savedValuations;
    }

    getValuationData() {
        if (this.result?.valuationResponse) {
            return {
                id: this.result.valuationResponse.id,
                created: this.result.valuationResponse.created,
                data: this.result.valuationResponse,
            };
        }
    }

    pushSaved(data) {
        const items = [...(data ?? [])];
        items.forEach((item) => {
            const find = this.savedValuations?.data?.find((saved) => saved.id === item.id);
            if (!find) {
                this.savedValuations?.data?.push(item);
            }
        });
    }

    reset() {
        this.enabled = false;
        this.id = null;
        this.finance = null;
        this.result = {};
    }
}
